export default __webpack_public_path__ + "static/media/beer.a4e37cc4.svg";